import { ICreatable } from "./ICreatable";

export class FactoryContainer<TSource, TInstance> implements ICreatable<TSource, TInstance> {
  constructor(...contents: ICreatable<TSource, TInstance>[]) {
    this._contents = contents;
  }

  private readonly _contents: ICreatable<TSource, TInstance>[];

  create(source: TSource): TInstance | null {
    for (const content of this._contents) {
      const instance = content.create(source);
      if (!!instance) {
        return instance;
      }
    }
    return null;
  }
}
